module.exports = __webpack_public_path__ + "media/auto_history/kontrola_drogowa-933abf75.svg";